import {getClientGDPRUrl} from '../../../url';
import PrintButton from '../ReactBootstrap/PrintButton';
import React from 'react';
import {printClientGDPR} from '../../../print';
import PropTypes from 'prop-types';

const ClientGDPRPrintButton = ({
    client,

    ...props
}) => {
    return (
        <PrintButton icon="file-alt" printAction={() => printClientGDPR(client.id)}
            viewUrl={getClientGDPRUrl(client.id)}
            downloadUrl={getClientGDPRUrl(client.id, true,)}
            objId={client.id} {...props} />
    );
};

ClientGDPRPrintButton.defaultProps = {
    label: 'GDPR Декларация',
    objType: 'client',
};

ClientGDPRPrintButton.propTypes = {
    label: PropTypes.string,
    objType: PropTypes.string,
    client: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }).isRequired,
};

export default ClientGDPRPrintButton;
